import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { BufferService, LoadingContext, M_Table, NavigateContext } from 'src/M_Components'

export const QuoteEquipmentDetailList = ({ roles }) => {
    const { t } = useTranslation()
    const ctx = useContext(LoadingContext)
    const ctx2 = useContext(NavigateContext)

    const newRoute = (url, operation, label, row) => {
        if (operation === 'Edit' || operation === 'Copy') {
            if (row) {
                sessionStorage.setItem('editingQuoteDetail', JSON.stringify(row))
                sessionStorage.setItem('operationType', operation)
            } else {
                return
            }
        }
        if (operation === 'Create') ctx.setPassValues({ Operation: operation })
        ctx2.newTab(url, label)
    }

    return (
        <>
            <M_Table
                entityName={'QuoteDetail'}
                api='primary'
                showTitle={true}
                title={'Quote Equipment Details'}
                roleName={'usersGroups'}
                rolePermissions={roles}
                replaceFunctions={new Map([
                    ['Create', (row) => newRoute('go/quoteEquipmentDetailCrud', 'Create', `${t('Add')} ${t('Quote Detail')}`, row)],
                    ['Edit',   (row) => newRoute('go/quoteEquipmentDetailCrud', 'Edit',   `${t('Edit')} ${t('Quote Detail')}`, row)],
                    ['Copy',   (row) => newRoute('go/quoteEquipmentDetailCrud', 'Copy',   `${t('Copy')} ${t('Quote Detail')}`, row)],
                ])}
                columnTemplates={[
                    {
                        field: 'Freight',
                        body: (rowData) => rowData.Freight != null ? parseFloat(rowData.Freight).toFixed(2) : '',
                        header: t('Freight'),
                    },
                    {
                        field: 'BAF',
                        body: (rowData) => rowData.BAF != null ? parseFloat(rowData.BAF).toFixed(2) : '',
                        header: t('BAF'),
                    },
                    {
                        field: 'THC',
                        body: (rowData) => rowData.THC != null ? parseFloat(rowData.THC).toFixed(2) : '',
                        header: t('THC'),
                    },
                    {
                        field: 'ImoSurcharge',
                        body: (rowData) => rowData.ImoSurcharge != null ? parseFloat(rowData.ImoSurcharge).toFixed(2) : '',
                        header: t('IMO Surcharge'),
                    },
                ]}
            />
        </>
    )
}